<template>
  <v-row class="fill-height" fluid>
    <v-container fluid>
      <v-subheader class="mb-5">
        <h1>Historial de citas</h1>
      </v-subheader>
      <v-row>
        <v-col cols="12" md="12" class="ma-0 pa-0">
          <v-row>
            <v-col cols="12" sm="12" md="3" lg="2">
              <v-menu
                v-model="menuFltFecIni"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :disabled="loading"
                    @click:append="menuFltFecIni = true"
                    append-icon="mdi-calendar"
                    class="ma-0 pa-0"
                    dense
                    hide-details
                    label="Fecha inicio cita"
                    outlined
                    placeholder="Fecha inicio cita"
                    readonly
                    v-bind="attrs"
                    v-model="fltFecInicio"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  @change="listar()"
                  @input="menuFltFecIni = false"
                  no-title
                  scrollable
                  v-model="fltFecInicio"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="12" md="3" lg="2">
              <v-menu
                v-model="menuFltFecFin"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :disabled="loading"
                    @click:append="menuFltFecFin = true"
                    append-icon="mdi-calendar"
                    class="ma-0 pa-0"
                    dense
                    hide-details
                    label="Fecha fin cita"
                    outlined
                    placeholder="Fecha fin cita"
                    readonly
                    v-bind="attrs"
                    v-model="fltFecFin"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  @change="listar()"
                  @input="menuFltFecFin = false"
                  no-title
                  scrollable
                  v-model="fltFecFin"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="12" md="3" lg="2">
              <v-select
                :disabled="loading"
                :items="itemsFltMant"
                @change="listar()"
                class="ma-0 pa-0"
                dense
                hide-details
                item-text="descripcion"
                item-value="codigo"
                label="Tipo Mant."
                outlined
                placeholder="Seleccione"
                v-model="fltMant"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="12" md="3" lg="2">
              <v-select
                :disabled="loading"
                :items="itemsFltEstado"
                @change="listar()"
                class="ma-0 pa-0"
                dense
                hide-details
                item-text="descripcion"
                item-value="codigo"
                label="Estado"
                outlined
                placeholder="Seleccione"
                v-model="fltEstado"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="12" md="11" lg="3">
              <v-text-field
                :disabled="loading"
                :placeholder="searchPlaceholder"
                @keyup.enter="listar()"
                append-icon="mdi-magnify"
                class="ma-0 pa-0"
                dense
                hide-details
                outlined
                label="Búsqueda"
                v-model="search"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="1" lg="1" class="d-flex justify-end">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :disabled="loading"
                    class="mr-2"
                    v-bind="attrs"
                    v-on="on"
                    @click="limpiarFiltros()"
                    style="background-color: #5cbbf6;"
                  >
                    <v-icon color="white" medium>mdi-broom</v-icon>
                  </v-btn>
                </template>
                <span>Limpiar</span>
              </v-tooltip>
            </v-col>
            <v-col cols="12" md="12">
              <v-data-table
                :footer-props="footerProps"
                :headers="headers"
                :items="items"
                :loading="loading"
                :options.sync="opciones"
                :server-items-length="totalCitas"
                class="elevation-1"
              >
                <template v-slot:item.rango="{ item }">{{
                  item.rango
                    ? tiempo(item.rango.hora_inicio, item.rango.minuto_inicio) +
                      " - " +
                      tiempo(item.rango.hora_fin, item.rango.minuto_fin)
                    : ""
                }}</template>
                <template v-slot:item.usuario_cliente="{ item }">{{
                  item.usuario_cliente.nombres
                }}</template>
                <template v-slot:item.tipo_mantenimiento="{ item }">{{
                  item.tipo_mantenimiento.descripcion
                }}</template>
                <template v-slot:item.estado="{ item }">{{
                  item.estado.descripcion
                }}</template>
                <template v-slot:item.acciones="{ item }">
                  <v-icon
                    v-if="vista.lectura"
                    medium
                    class="mr-2"
                    @click.stop="editar(item, false)"
                    >mdi-eye</v-icon
                  >
                  <v-icon
                    v-if="vista.escritura"
                    medium
                    class="mr-2"
                    @click.stop="editar(item, true)"
                    :disabled="item.estado.codigo !== 'P'"
                    >mdi-pencil</v-icon
                  >
                  <v-icon
                    v-if="vista.supresion"
                    medium
                    class="mr-2"
                    @click="cancelar(item)"
                    :disabled="item.estado.codigo !== 'P'"
                    >mdi-close</v-icon
                  >
                  <v-icon
                    v-if="vista.post_venta"
                    medium
                    class="mr-2"
                    @click="calificar(item)"
                    :disabled="item.estado.codigo !== 'A'"
                    >mdi-comment-check-outline</v-icon
                  >
                </template>
              </v-data-table>
              <br />
              <v-btn
                v-if="vista.escritura"
                fab
                dark
                large
                color="primary"
                fixed
                right
                bottom
                @click="nuevo"
              >
                <v-icon dark>add</v-icon>
              </v-btn>
              <v-dialog v-model="dialogo.open" persistent max-width="650px">
                <v-card>
                  <v-card-title>
                    <span class="headline">{{ dialogo.titulo }}</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col
                          cols="12"
                          sm="12"
                          md="12"
                          lg="12"
                          v-if="!vista.cliente"
                        >
                          <v-text-field
                            class="ma-0 pa-0"
                            dense
                            disabled
                            hide-details
                            label="Cliente"
                            outlined
                            placeholder="Cliente"
                            v-model="dialogo.cliente.nombres"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="6" lg="3">
                          <v-text-field
                            class="ma-0 pa-0"
                            dense
                            disabled
                            hide-details
                            label="Fecha cita"
                            outlined
                            placeholder="Fecha cita"
                            v-model="dialogo.fecha"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="6" lg="5">
                          <v-text-field
                            class="ma-0 pa-0"
                            dense
                            disabled
                            hide-details
                            label="Tipo de Mantenimiento"
                            outlined
                            placeholder="Tipo de Mantenimiento"
                            v-model="dialogo.tipoMant.descripcion"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="6" lg="4">
                          <v-text-field
                            class="ma-0 pa-0"
                            dense
                            disabled
                            hide-details
                            label="Estado"
                            outlined
                            placeholder="Estado"
                            v-model="dialogo.estado"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="6" lg="6">
                          <v-text-field
                            class="ma-0 pa-0"
                            dense
                            disabled
                            hide-details
                            label="Vehículo"
                            outlined
                            placeholder="Vehículo"
                            v-model="dialogo.vehiculo"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="6" lg="6">
                          <v-text-field
                            class="ma-0 pa-0 input-decimal"
                            dense
                            disabled
                            hide-details
                            label="Kilometraje"
                            outlined
                            placeholder="Kilometraje"
                            v-model="dialogo.kilometraje"
                            @blur="
                              dialogo.kilometraje = numero(dialogo.kilometraje)
                            "
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" lg="12">
                          <v-textarea
                            class="ma-0 pa-0"
                            dense
                            :disabled="!dialogo.edicion || dialogo.loading"
                            hide-details
                            label="Observaciones"
                            outlined
                            placeholder="Ingrese observaciones"
                            rows="2"
                            v-model="dialogo.observaciones"
                          ></v-textarea>
                        </v-col>
                        <v-col
                          v-if="dialogo.codEstado == 'C'"
                          cols="12"
                          sm="12"
                          md="12"
                          lg="12"
                        >
                          <v-textarea
                            class="ma-0 pa-0"
                            dense
                            :disabled="!dialogo.edicion || dialogo.loading"
                            hide-details
                            label="Motivo cancela"
                            outlined
                            placeholder="Motivo"
                            rows="2"
                            v-model="dialogo.motivo_cancela"
                          >
                          </v-textarea>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      :disabled="dialogo.loading"
                      @click.stop="cerrar()"
                      color="blue darken-1"
                      text
                      >Cerrar</v-btn
                    >
                    <v-btn
                      :disabled="dialogo.loading"
                      @click.stop="guardar()"
                      color="blue darken-1"
                      text
                      v-if="dialogo.edicion"
                      >Guardar</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="dialogo2.open" persistent max-width="650px">
                <v-card>
                  <v-card-title>
                    <span class="headline">
                      Seguimiento de atención Post-Venta
                    </span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="12" md="6" lg="4">
                          <v-text-field
                            :disabled="dialogo2.loading"
                            @input.native="validar()"
                            @keyup.enter="guardar2()"
                            class="ma-0 pa-0 vtf-calidad"
                            dense
                            hide-details
                            label="Calidad de Servicio"
                            outlined
                            placeholder="Calidad de Servicio"
                            type="number"
                            v-model="dialogo2.calidad"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="6" lg="8" class="d-flex">
                          <label class="align-self-center"
                            >Mín: {{ califMin }} (Pésimo), Máx:
                            {{ califMax }} (Muy Bueno)</label
                          >
                        </v-col>
                        <v-col cols="12" sm="12" md="12" lg="12">
                          <v-textarea
                            :disabled="dialogo2.loading"
                            @keyup.enter="guardar2()"
                            class="ma-0 pa-0"
                            dense
                            hide-details
                            label="Comentarios"
                            outlined
                            placeholder="Ingrese comentarios"
                            rows="2"
                            v-model="dialogo2.comentarios"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      :disabled="dialogo2.loading"
                      @click.stop="cerrar2()"
                      color="blue darken-1"
                      text
                    >
                      Cerrar
                    </v-btn>
                    <v-btn
                      :disabled="dialogo2.loading"
                      @click.stop="guardar2()"
                      color="blue darken-1"
                      text
                    >
                      Guardar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="dialogo3.open" persistent max-width="350px">
                <v-card>
                  <v-card-title>
                    <span class="headline">
                      ¿Cancelar Cita?
                    </span>
                  </v-card-title>
                  <v-card-text class="pb-0">
                    <v-textarea
                      dense
                      outlined
                      label="Motivo"
                      placeholder="Máximo 200 caracteres"
                      class="mt-4"
                      rows="4"
                      v-model="dialogo3.motivo"
                      :error-messages="dialogo3.error"
                      @input="dialogo3.error = ''"
                      @keydown.enter.exact.prevent
                      @keyup.enter.exact="cerrarDlgCancelar(true)"
                      @keyup.esc="cerrarDlgCancelar(false)"
                      :maxlength="200"
                    ></v-textarea>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      @click.stop="cerrarDlgCancelar(false)"
                      color="blue darken-1"
                      text
                    >
                      No
                    </v-btn>
                    <v-btn
                      @click.stop="cerrarDlgCancelar(true)"
                      color="blue darken-1"
                      text
                    >
                      Si
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "axios";

export default {
  name: "Historial",
  data: () => ({
    headers: [],
    totalCitas: 0,
    opciones: { sortBy: ["fecha_registro"], sortDesc: [true] },
    loading: false,
    items: [],
    dialogo: {
      cliente: { username: "", nombres: "" },
      edicion: false,
      estado: "",
      codEstado: "",
      fecha: "",
      loading: false,
      observaciones: "",
      open: false,
      placa: "",
      tipoMant: { codigo: "", descripcion: "" },
      titulo: "",
      vehiculo: "",
      kilometraje: "",
      id: 0,
      motivo_cancela: ""
    },
    dialogo2: {
      calidad: 0,
      cliente: "",
      comentarios: "",
      fecha: "",
      loading: false,
      open: false,
      placa: "",
      tipoMant: "",
      id: 0
    },
    dialogo3: {
      open: false,
      resolve: null,
      motivo: "",
      error: ""
    },
    footerProps: { "items-per-page-options": [15, 30, 50, 100] },
    searchPlaceholder: "",
    search: "",
    itemsFltMant: [{ codigo: "", descripcion: "Todos" }],
    fltMant: "",
    itemsFltEstado: [{ codigo: "", descripcion: "Todos" }],
    fltEstado: "",
    vista: {},
    califMin: 0,
    califMax: 0,
    menuFltFecIni: false,
    fltFecInicio: "",
    menuFltFecFin: false,
    fltFecFin: ""
  }),
  watch: {
    opciones: {
      handler() {
        this.listar();
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters(["getToken"])
  },
  methods: {
    ...mapActions(["setToken", "showAlerta2", "hideAlerta2"]),
    tiempo(dia, hora) {
      let diaStr = "00" + dia;
      let horaStr = "00" + hora;
      return (
        diaStr.substr(diaStr.length - 2) +
        ":" +
        horaStr.substr(horaStr.length - 2)
      );
    },
    numero(valor) {
      let numero = parseFloat(valor);

      if (isNaN(numero) || numero < 0) {
        numero = 0;
      }

      return numero.toFixed();
    },
    limpiarFiltros() {
      this.fltFecInicio = "";
      this.fltFecFin = "";
      this.fltEstado = "";
      this.fltMant = "";
      this.search = "";
      this.listar();
    },
    abrirDlgCancelar() {
      return new Promise(resolve => {
        this.dialogo3.motivo = "";
        this.dialogo3.resolve = resolve;
        this.dialogo3.open = true;
      });
    },
    cerrarDlgCancelar(resultado) {
      if (resultado && this.dialogo3.motivo.trim() == "") {
        this.dialogo3.error = "** Se requiere un motivo";
        return;
      }
      this.dialogo3.open = false;
      this.dialogo3.resolve(resultado);
      this.dialogo3.error = "";
      this.dialogo3.resolve = null;
    },
    async loadVista() {
      let respuesta;
      try {
        respuesta = await axios.get(
          process.env.VUE_APP_BASE_PATH +
            `/api/usuario/ObtenerVista?vista=HISTORIAL`,
          {
            headers: { Authorization: `Bearer ${this.getToken}` }
          }
        );
      } catch (error) {
        if (error.response.status == 400) {
          this.showAlerta2({
            mensaje: error.response.data.error_description,
            tipo: 3
          });
        } else {
          this.salir();
        }
        return;
      }

      this.vista = respuesta.data;
    },
    async listar() {
      if (this.loading) {
        return;
      }
      const { sortBy, sortDesc, page, itemsPerPage } = this.opciones;
      const params = {
        sortBy,
        sortDesc,
        page,
        itemsPerPage,
        search: this.search,
        cliente: this.vista.cliente,
        tipo_mantenimiento: this.fltMant,
        estado: this.fltEstado,
        fec_ini_cita: this.fltFecInicio,
        fec_fin_cita: this.fltFecFin
      };

      let respuesta;
      try {
        this.loading = true;
        respuesta = await axios.post(
          process.env.VUE_APP_BASE_PATH + "/api/cita/listar",
          params,
          {
            headers: { Authorization: `Bearer ${this.getToken}` }
          }
        );
      } catch (error) {
        if (error.response.status == 400) {
          this.showAlerta2({
            mensaje: error.response.data.error_description,
            tipo: 3
          });
        } else {
          this.salir();
        }

        return;
      } finally {
        this.loading = false;
      }

      this.totalCitas = respuesta.data.total;

      this.items = respuesta.data.lista.map((el, idx) => {
        return {
          ...el,
          acciones: null
        };
      });
    },
    async listarEstados() {
      let respuesta;
      try {
        respuesta = await axios.get(
          process.env.VUE_APP_BASE_PATH + "/api/cita/ListarEstados",
          {
            headers: { Authorization: `Bearer ${this.getToken}` }
          }
        );
      } catch (error) {
        if (error.response.status == 400) {
          this.showAlerta2({
            mensaje: error.response.data.error_description,
            tipo: 3
          });
        } else {
          this.salir();
        }
        return;
      }

      this.itemsFltEstado = this.itemsFltEstado.concat(respuesta.data);
    },
    async listarTiposMant() {
      let respuesta;
      try {
        respuesta = await axios.get(
          process.env.VUE_APP_BASE_PATH + "/api/config/ListarTiposMant",
          {
            headers: { Authorization: `Bearer ${this.getToken}` }
          }
        );
      } catch (error) {
        if (error.response.status == 400) {
          this.showAlerta2({
            mensaje: error.response.data.error_description,
            tipo: 3
          });
        } else {
          this.salir();
        }
        return;
      }

      this.itemsFltMant = this.itemsFltMant.concat(respuesta.data);
    },
    async obtenerParamCalificacion() {
      let respuesta;
      try {
        respuesta = await axios.get(
          process.env.VUE_APP_BASE_PATH +
            "/api/config/ListarParametrosCalificacion",
          {
            headers: { Authorization: `Bearer ${this.getToken}` }
          }
        );
      } catch (error) {
        if (error.response.status == 400) {
          this.showAlerta2({
            mensaje: error.response.data.error_description,
            tipo: 3
          });
        } else {
          this.salir();
        }
        return;
      }
      let parametro;

      parametro = respuesta.data.find(x => x.codigo == "MIN_CALIF_CITA");
      this.califMin = parametro != undefined ? parseInt(parametro.valor) : 0;
      parametro = respuesta.data.find(x => x.codigo == "MAX_CALIF_CITA");
      this.califMax = parametro != undefined ? parseInt(parametro.valor) : 0;
    },
    nuevo() {
      this.$router.push({ path: "/Index/Cita" });
    },
    editar(item, edicion) {
      this.dialogo.titulo = (edicion ? "Edición" : "Consulta") + " de Cita";
      this.dialogo.edicion = edicion;
      this.dialogo.codEstado = item.estado.codigo;
      this.dialogo.open = true;

      (async instancia => {
        const params = {
          id: item.id,
          cliente: instancia.vista.cliente,
          fecha: item.fecha,
          placa: item.placa,
          tipo_mantenimiento: {
            codigo: item.tipo_mantenimiento.codigo
          },
          usuario_cliente: {
            username: item.usuario_cliente.username
          }
        };

        let respuesta;
        try {
          respuesta = await axios.post(
            process.env.VUE_APP_BASE_PATH + "/api/cita/obtener",
            params,
            { headers: { Authorization: `Bearer ${instancia.getToken}` } }
          );
        } catch (error) {
          if (error.response.status == 400) {
            instancia.showAlerta2({
              mensaje: error.response.data.error_description,
              tipo: 3
            });
          } else {
            instancia.salir();
          }
          return;
        }

        instancia.dialogo.fecha = respuesta.data.fecha;
        instancia.dialogo.cliente = respuesta.data.usuario_cliente;
        instancia.dialogo.tipoMant = respuesta.data.tipo_mantenimiento;
        instancia.dialogo.estado = respuesta.data.estado.descripcion;
        instancia.dialogo.placa = respuesta.data.placa;
        instancia.dialogo.vehiculo = respuesta.data.vehiculo;
        instancia.dialogo.observaciones = respuesta.data.observaciones;
        instancia.dialogo.kilometraje = this.numero(respuesta.data.kilometraje);
        instancia.dialogo.motivo_cancela = respuesta.data.motivo_cancela;
        instancia.dialogo.id = respuesta.data.id;
      })(this);
    },
    async guardar() {
      const params = {
        id: this.dialogo.id,
        cliente: this.vista.cliente,
        fecha: this.dialogo.fecha,
        placa: this.dialogo.placa,
        usuario_cliente: {
          username: this.dialogo.cliente.username
        },
        tipo_mantenimiento: {
          codigo: this.dialogo.tipoMant.codigo
        },
        observaciones: this.dialogo.observaciones
      };

      let respuesta;
      try {
        this.dialogo.loading = true;
        respuesta = await axios.post(
          process.env.VUE_APP_BASE_PATH + "/api/cita/Guardar",
          params,
          {
            headers: { Authorization: `Bearer ${this.getToken}` }
          }
        );
      } catch (error) {
        if (error.response.status == 400) {
          this.showAlerta2({
            mensaje: error.response.data.error_description,
            tipo: 3
          });
        } else {
          this.salir();
        }
        return;
      } finally {
        this.dialogo.loading = false;
      }

      this.showAlerta2({
        mensaje: respuesta.data.mensaje,
        tipo: respuesta.data.tipo
      });

      if (respuesta.data.tipo == 0) {
        this.cerrar();
      }
    },
    async guardar2() {
      const params = {
        id: this.dialogo2.id,
        fecha: this.dialogo2.fecha,
        placa: this.dialogo2.placa,
        usuario_cliente: {
          username: this.dialogo2.cliente
        },
        tipo_mantenimiento: {
          codigo: this.dialogo2.tipoMant
        },
        calidad: this.dialogo2.calidad,
        comentarios: this.dialogo2.comentarios
      };

      let respuesta;
      try {
        this.dialogo2.loading = true;
        respuesta = await axios.post(
          process.env.VUE_APP_BASE_PATH + "/api/cita/GuardarCalificacion",
          params,
          {
            headers: { Authorization: `Bearer ${this.getToken}` }
          }
        );
      } catch (error) {
        if (error.response.status == 400) {
          this.showAlerta2({
            mensaje: error.response.data.error_description,
            tipo: 3
          });
        } else {
          this.salir();
        }
        return;
      } finally {
        this.dialogo2.loading = false;
      }

      this.showAlerta2({
        mensaje: respuesta.data.mensaje,
        tipo: respuesta.data.tipo
      });

      if (respuesta.data.tipo == 0) {
        this.cerrar2();
      }
    },
    async calificar(item) {
      this.dialogo2.open = true;

      const params = {
        id: item.id,
        fecha: item.fecha,
        placa: item.placa,
        tipo_mantenimiento: {
          codigo: item.tipo_mantenimiento.codigo
        },
        usuario_cliente: {
          username: item.usuario_cliente.username
        }
      };

      let respuesta;
      try {
        respuesta = await axios.post(
          process.env.VUE_APP_BASE_PATH + "/api/cita/ObtenerCalificacion",
          params,
          { headers: { Authorization: `Bearer ${this.getToken}` } }
        );
      } catch (error) {
        if (error.response.status == 400) {
          this.showAlerta2({
            mensaje: error.response.data.error_description,
            tipo: 3
          });
        } else {
          this.salir();
        }
        return;
      }
      this.dialogo2.id = respuesta.data.id;
      this.dialogo2.calidad = respuesta.data.calidad;
      this.dialogo2.comentarios = respuesta.data.comentarios;
      this.dialogo2.fecha = respuesta.data.fecha;
      this.dialogo2.cliente = respuesta.data.usuario_cliente.username;
      this.dialogo2.tipoMant = respuesta.data.tipo_mantenimiento.codigo;
      this.dialogo2.placa = respuesta.data.placa;
      this.validar();
    },
    validar() {
      if (this.dialogo2.calidad > this.califMax) {
        this.dialogo2.calidad = this.califMax;
      } else if (this.dialogo2.calidad < this.califMin) {
        this.dialogo2.calidad = this.califMin;
      }
    },
    async cancelar(item) {
      if (!(await this.abrirDlgCancelar())) {
        return;
      }

      const params = {
        id: item.id,
        cliente: this.vista.cliente,
        fecha: item.fecha,
        placa: item.placa,
        usuario_cliente: {
          username: item.usuario_cliente.username
        },
        tipo_mantenimiento: {
          codigo: item.tipo_mantenimiento.codigo
        },
        motivo_cancela: this.dialogo3.motivo
      };

      let respuesta;
      try {
        respuesta = await axios.post(
          process.env.VUE_APP_BASE_PATH + "/api/cita/Cancelar",
          params,
          {
            headers: { Authorization: `Bearer ${this.getToken}` }
          }
        );
      } catch (error) {
        if (error.response.status == 400) {
          this.showAlerta2({
            mensaje: error.response.data.error_description,
            tipo: 3
          });
        } else {
          this.salir();
        }
        return;
      }

      this.showAlerta2({
        mensaje: respuesta.data.mensaje,
        tipo: respuesta.data.tipo
      });

      if (respuesta.data.tipo == 0) {
        this.listar();
      }
    },
    cerrar() {
      this.dialogo.open = false;
      this.dialogo.cliente = { username: "", nombres: "" };
      this.dialogo.edicion = false;
      this.dialogo.estado = "";
      this.dialogo.codEstado = "";
      this.dialogo.fecha = "";
      this.dialogo.loading = false;
      this.dialogo.observaciones = "";
      this.dialogo.placa = "";
      this.dialogo.tipoMant = { codigo: "", descripcion: "" };
      this.dialogo.titulo = "";
      this.dialogo.vehiculo = "";
      this.dialogo.kilometraje = "";
      this.dialogo.id = 0;
      this.dialogo.motivo_cancela = "";
    },
    cerrar2() {
      this.dialogo2.open = false;
      this.dialogo2.calidad = 0;
      this.dialogo2.cliente = "";
      this.dialogo2.comentarios = "";
      this.dialogo2.fecha = "";
      this.dialogo2.loading = false;
      this.dialogo2.placa = "";
      this.dialogo2.tipoMant = "";
      this.dialogo2.id = 0;
    },
    salir() {
      this.setToken("");
      this.$router.push({ path: "/Login" });
    }
  },
  async created() {
    await this.loadVista();
    this.obtenerParamCalificacion();
    this.listarTiposMant();
    this.listarEstados();

    this.searchPlaceholder = (!this.vista.cliente ? "Cliente, " : "") + "Placa";

    let headers = [
      {
        text: "#",
        align: "start",
        sortable: false,
        value: "correlativo"
      },
      { text: "Fecha Registro", value: "fecha_registro" },
      { text: "Fecha Cita", value: "fecha" },
      { text: "H. Recepción", value: "rango", sortable: false }
    ];

    if (!this.vista.cliente) {
      headers.push({ text: "Cliente", value: "usuario_cliente" });
    }

    headers.push({
      text: "T. Mantenimiento",
      value: "tipo_mantenimiento"
    });
    headers.push({ text: "Placa", value: "placa" });
    headers.push({ text: "Estado", value: "estado" });
    // headers.push({ text: "Fecha Registro", value: "fecha_registro" });
    headers.push({ text: "Acciones", value: "acciones", sortable: false });

    this.headers = headers;
  }
};
</script>

<style>
.vtf-calidad input[type="number"] {
  text-align: right;
}
</style>
